import { useState, useCallback } from 'react';

/**
 * Hook personnalisé pour gérer le choix de paiement
 * Utilisable partout où il y a un bouton "Acheter"
 */
export const usePaymentChoice = () => {
  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [selectedPurchase, setSelectedPurchase] = useState(null);

  const openPaymentModal = useCallback((purchase) => {
    setSelectedPurchase(purchase);
    setPaymentModalOpen(true);
  }, []);

  const closePaymentModal = useCallback(() => {
    setPaymentModalOpen(false);
    setSelectedPurchase(null);
  }, []);

  return {
    paymentModalOpen,
    selectedPurchase,
    openPaymentModal,
    closePaymentModal,
    setPaymentModalOpen
  };
};

export default usePaymentChoice;
